var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var Set_Auth0_User_Id_In_UserDocument = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation set_auth0_user_id_in_user($Email: String!, $Auth0UserId: String!) {\n  update_user(where: {Email: {_eq: $Email}}, _set: {Auth0UserId: $Auth0UserId}) {\n    affected_rows\n  }\n}\n    "], ["\n    mutation set_auth0_user_id_in_user($Email: String!, $Auth0UserId: String!) {\n  update_user(where: {Email: {_eq: $Email}}, _set: {Auth0UserId: $Auth0UserId}) {\n    affected_rows\n  }\n}\n    "])));
/**
 * __useSet_Auth0_User_Id_In_UserMutation__
 *
 * To run a mutation, you first call `useSet_Auth0_User_Id_In_UserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSet_Auth0_User_Id_In_UserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAuth0UserIdInUserMutation, { data, loading, error }] = useSet_Auth0_User_Id_In_UserMutation({
 *   variables: {
 *      Email: // value for 'Email'
 *      Auth0UserId: // value for 'Auth0UserId'
 *   },
 * });
 */
export function useSet_Auth0_User_Id_In_UserMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(Set_Auth0_User_Id_In_UserDocument, options);
}
export var Leads_With_Auth0_IdDocument = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    query leads_with_auth0_id($Email: String!) {\n  new_leads(where: {Email: {_eq: $Email}}) {\n    id\n    user {\n      Auth0UserId\n      CognitoUserId\n    }\n  }\n}\n    "], ["\n    query leads_with_auth0_id($Email: String!) {\n  new_leads(where: {Email: {_eq: $Email}}) {\n    id\n    user {\n      Auth0UserId\n      CognitoUserId\n    }\n  }\n}\n    "])));
/**
 * __useLeads_With_Auth0_IdQuery__
 *
 * To run a query within a React component, call `useLeads_With_Auth0_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeads_With_Auth0_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeads_With_Auth0_IdQuery({
 *   variables: {
 *      Email: // value for 'Email'
 *   },
 * });
 */
export function useLeads_With_Auth0_IdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(Leads_With_Auth0_IdDocument, options);
}
export function useLeads_With_Auth0_IdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(Leads_With_Auth0_IdDocument, options);
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUXVlcmllcy5ncWwuanN4Iiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiUXVlcmllcy5ncWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUVBLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUNyQyxPQUFPLEtBQUssTUFBTSxNQUFNLGdCQUFnQixDQUFDO0FBQ3pDLElBQU0sY0FBYyxHQUFHLEVBQVcsQ0FBQztBQWlCbkMsTUFBTSxDQUFDLElBQU0saUNBQWlDLEdBQUcsR0FBRywyUUFBQSx3TUFNL0MsSUFBQSxDQUFDO0FBR047Ozs7Ozs7Ozs7Ozs7Ozs7O0dBaUJHO0FBQ0gsTUFBTSxVQUFVLG9DQUFvQyxDQUFDLFdBQXVIO0lBQ3BLLElBQU0sT0FBTyx5QkFBTyxjQUFjLEdBQUssV0FBVyxDQUFDLENBQUE7SUFDbkQsT0FBTyxNQUFNLENBQUMsV0FBVyxDQUFnRixpQ0FBaUMsRUFBRSxPQUFPLENBQUMsQ0FBQztBQUN2SixDQUFDO0FBSVAsTUFBTSxDQUFDLElBQU0sMkJBQTJCLEdBQUcsR0FBRyxzUEFBQSxtTEFVekMsSUFBQSxDQUFDO0FBRU47Ozs7Ozs7Ozs7Ozs7OztHQWVHO0FBQ0gsTUFBTSxVQUFVLDJCQUEyQixDQUFDLFdBQWlHO0lBQ3JJLElBQU0sT0FBTyx5QkFBTyxjQUFjLEdBQUssV0FBVyxDQUFDLENBQUE7SUFDbkQsT0FBTyxNQUFNLENBQUMsUUFBUSxDQUE4RCwyQkFBMkIsRUFBRSxPQUFPLENBQUMsQ0FBQztBQUM1SCxDQUFDO0FBQ1AsTUFBTSxVQUFVLCtCQUErQixDQUFDLFdBQXNHO0lBQzVJLElBQU0sT0FBTyx5QkFBTyxjQUFjLEdBQUssV0FBVyxDQUFDLENBQUE7SUFDbkQsT0FBTyxNQUFNLENBQUMsWUFBWSxDQUE4RCwyQkFBMkIsRUFBRSxPQUFPLENBQUMsQ0FBQztBQUNoSSxDQUFDIn0=